import type { ReactNode } from 'react';

type DisplayableProps = {
  children: ReactNode;
  displayCondition: boolean | (() => boolean);
  className?: string;
};

export function Displayable({
  children,
  displayCondition,
  ...forwardingProps
}: DisplayableProps) {
  if (
    typeof displayCondition === 'function'
      ? displayCondition()
      : displayCondition
  ) {
    return <div {...forwardingProps}>{children}</div>;
  }
  return null;
}

export const isDisplayable =
  <T extends string[]>(elements: T) =>
  <V,>(displayable: string, required?: V | undefined): boolean => {
    const checkRequired = (value: V | undefined) => {
      if (typeof value === 'undefined') {
        return true;
      }
      return !!value;
    };

    return elements.includes(displayable) && checkRequired(required);
  };
